import * as React from 'react'
import { ViolationModel } from '@/app/models/violationModel'
import { GroupedViolationModel } from '@/app/models/groupedViolationModel'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  violations?: ViolationModel[]
  groupedViolations?: GroupedViolationModel[]
}

const ViolationSummary: React.FC<Props> = ({ violations, groupedViolations }) => {
  const { t } = useLocalize()

  const calculateSum = (): GroupedViolationModel => {
    if (violations && violations.length > 0) {
      return violations.reduce(
        (accumulated: GroupedViolationModel, current: ViolationModel) => {
          accumulated.driverCharge += current.driverCharge || 0
          accumulated.companyCharge += current.companyCharge || 0
          return accumulated
        },
        { driverCharge: 0, companyCharge: 0 },
      )
    }
    if (groupedViolations && groupedViolations.length > 0) {
      return groupedViolations.reduce(
        (accumulated: GroupedViolationModel, current: GroupedViolationModel) => {
          accumulated.driverCharge += current.driverCharge || 0
          accumulated.companyCharge += current.companyCharge || 0
          return accumulated
        },
        { driverCharge: 0, companyCharge: 0 },
      )
    }
    return { driverCharge: 0, companyCharge: 0 }
  }

  const formatNumber = (value: number): string => {
    return Number(value.toFixed(2)).toLocaleString() + ' PLN'
  }

  const summary = calculateSum()

  return (
    <div className="tw-flex tw-h-10 tw-items-center tw-bg-white tw-px-4 tw-text-[15px] tw-font-medium tw-text-[#343434]">
      <span className="tw-uppercase">
        {t('driverViolations.charge-sum')}
      </span>
      <span className="tw-ml-6">
        {`${formatNumber(summary.driverCharge)} / ${formatNumber(summary.companyCharge)}`}
      </span>
    </div>
  )
}

export default ViolationSummary






















